import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../../../contexts/AppContext';
import { WorkerDocument } from '../../../app/models/Workers';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import GeneralDocumentForm from '../../../components/GeneralDocumentForm';
import useSocietyDocumentService from '../../../app/services/hooks/useSocietyDocumentService';
import { SocietyDocument, defaultSocietyDocument } from '../../../app/models/Society';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    societyId: number;
    typeDocument: string;
}

const SocietyDocumentEdit = ({ onSaved, onCancel, onError, typeDocument, societyId }: Props) => {

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [societyDocument, setSocietyDocument] = useState<SocietyDocument>(defaultSocietyDocument);
    const [errorFields, setErrorFields] = useState<any>();
    const { fetchingEditSocietyDocument,
        fetchingUpdateSocietyDocument,
        editSocietyDocument,
        updateSocietyDocument } = useSocietyDocumentService();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Guardando documento...');
        editSocietyDocument(societyId, parseInt(typeDocument), {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setSocietyDocument(response.data.society_document)
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const update = () => {
        if (!societyDocument) return;
        if (showLoading) showLoading('loading', 'Guardando documento...');
        updateSocietyDocument(societyDocument.id!, societyDocument, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <GeneralDocumentForm
                        document={societyDocument}
                        setDocument={setSocietyDocument}
                        errorFields={errorFields}
                        edit={true}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingUpdateSocietyDocument}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm 
                        callbackSave={update} 
                        locked={fetchingUpdateSocietyDocument} 
                    />
                </div>
            </div>
        </>
    );
};

export default SocietyDocumentEdit;
